import { Outlet } from "react-router-dom";
import { useI18n } from "@/locales/i18n-provider";
import { AppShell } from "@/surfaces/standalone/layouts/app-shell";
import { SystemConfigurationSidebar } from "@/surfaces/standalone/layouts/system-config/sidebar";
import { SettingsDraftProvider } from "@/surfaces/standalone/pages/settings/components/settings-draft-provider";

export function SystemConfigurationLayout() {
  const { t } = useI18n();
  return (
    <SettingsDraftProvider>
      <AppShell navigationTitle={t("shell.systemNavigation")} renderSidebar={(options) => <SystemConfigurationSidebar {...options} />}>
        <Outlet />
      </AppShell>
    </SettingsDraftProvider>
  );
}
